module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-wrap"
  }, [_c('div', {
    staticClass: "el-loading-mask is-fullscreen"
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])]), _vm._v(" "), _c('z-lazyImg', {
    staticClass: "bg",
    attrs: {
      "placeImg": _vm.bg_small,
      "src": _vm.bg,
      "mask": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-08cd22ae!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/home-wait.vue
// module id = 687
// module chunks = 1